import SeasonalPaywall, {
  SeasonalPaywallColors,
} from "../SeasonalPaywall/SeasonalPaywall"
import useStrings from "../../localization/useStrings"
import BlackFriday2025Header from "./BlackFriday2025Header/BlackFriday2025Header"
import styles from "./BlackFriday2025Paywall.module.scss"

const blackFriday2025Colors: SeasonalPaywallColors = {
  scrollableGradient: "linear-gradient(180deg, #000000 0%, #000000 100%)",
  content: {
    background: "#000000",
    ultimateContainerBackground: "#CF3736",
    ultimateContainerText: "#ffffff",
    ultimateContainerMarginTop: "0px",
  },
  features: {
    icon: "#ffffff",
    title: "#ffffff",
    description: "rgba(255, 255, 255, 0.6)",
    infoButton: "#ffffff",
  },
  footer: {
    background: "#212121",
    primaryButton: {
      background: "#CF3736",
      headerBackground: "#CF3736",
      contentBackground: "#000000",
      limitedTimeText: "rgba(255, 255, 255, 0.9)",
      saveTagText: "rgba(255, 255, 255, 0.9)",
      planTitle: "rgba(255, 255, 255, 0.9)",
      duration: "rgba(255, 255, 255, 0.6)",
      originalPrice: "rgba(255, 255, 255, 0.6)",
      discountedPrice: "rgba(255, 255, 255, 0.9)",
      monthlyRate: "rgba(255, 255, 255, 0.9)",
    },
    monthlyButton: {
      background: "#000000",
      border: "1px solid rgba(255, 255, 255, 0.2)",
      label: "rgba(255, 255, 255, 0.9)",
      price: "rgba(255, 255, 255, 0.9)",
    },
  },
  insets: {
    header: "#000000",
    footer: "#212121",
  },
  closeButton: "#ffffff",
}

const BlackFriday2025Paywall = () => {
  const strings = useStrings()

  return (
    <SeasonalPaywall
      customHeader={<BlackFriday2025Header />}
      footerBackground={<div className={styles.footerBackground} />}
      colors={blackFriday2025Colors}
      strings={{
        title: "",
        tagline: "",
        buttonTitle: strings.premiumToUltimateBlackFriday.saleTitle,
      }}
      topInsetPercent={0}
    />
  )
}

export default BlackFriday2025Paywall
